import React from 'react';
import { DebouncedSearchField } from '../../commonComponents/DebouncedSearchField';
import { SelectFilter } from '../../commonComponents/filters/SelectFilter';

// Both selects send their 'all' sentinel through verbatim, as the native
// selects they replace did — the referral fetch expects that literal.
const STATUS_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'completed', label: 'Completed' },
  { value: 'finished', label: 'Finished' },
  { value: 'unfinished', label: 'Unfinished' },
];

const REFERRER_TYPE_OPTIONS = [
  { value: 'all', label: 'All' },
  { value: 'DNT', label: 'DNT' },
  { value: 'HYG', label: 'HYG' },
];

/** The Referral list's filter fields, for ListPage's `filters` card. */
export const Filters = ({ filter, handleFilterChange }) => (
  <>
    <DebouncedSearchField
      label="Search"
      value={filter?.searchText}
      onChange={(value) => handleFilterChange('searchText', value)}
    />

    <SelectFilter
      label="Status"
      options={STATUS_OPTIONS}
      value={filter.payFilter}
      onChange={(payFilter) => handleFilterChange('payFilter', payFilter)}
    />

    <SelectFilter
      label="Referrer Type"
      options={REFERRER_TYPE_OPTIONS}
      value={filter.referrerType}
      onChange={(referrerType) => handleFilterChange('referrerType', referrerType)}
    />
  </>
);
